import { PeriodSwitcher } from "@nymbl/nos2-rules";

interface YearSwitcherProps {
  year: number;
  onChange: (year: number) => void;
  /** The calendar year today; "This year" is disabled while it is shown. */
  currentYear: number;
}

/** "This year", ‹ 2026 › (UI standard 9). */
export function YearSwitcher({ year, onChange, currentYear }: YearSwitcherProps) {
  return (
    <PeriodSwitcher
      unit="year"
      label={String(year)}
      isCurrent={year === currentYear}
      onPrev={() => onChange(year - 1)}
      onNext={() => onChange(year + 1)}
      onCurrent={() => onChange(currentYear)}
      labelClassName="w-14"
    />
  );
}
